import { SortParams } from '@epicuro-next/data/baskets';
import { createReducer, on } from '@ngrx/store';
import {
  BasketGroupSortType,
  BasketRowsGroupType,
  SortDirection,
} from 'graphql-api/baskets-api-interfaces';

import {
  applySortingBasketItems,
  basketGroupingChanged,
  initSortingBasketItems,
  resolveActiveBasketComplete,
} from '../actions';

export const basketOptionsFeatureKey = 'options';

export const FALLBACK_SORT_PARAMS: Required<SortParams> = {
  type: BasketGroupSortType.Delivery,
  direction: SortDirection.Asc,
};

export interface State {
  /** The id of the currently selected basket grouping */
  selectedGroupingType: BasketRowsGroupType | null;
  /** Boolean to check if active basket resolved during initialize loading */
  activeBasketIdResolved: boolean;
  activeSortingType: BasketGroupSortType;
  activeSortingDirection: SortDirection;
}

export const initialState: State = {
  selectedGroupingType: null,
  activeBasketIdResolved: false,
  activeSortingType: FALLBACK_SORT_PARAMS.type,
  activeSortingDirection: FALLBACK_SORT_PARAMS.direction,
};

export const reducer = createReducer(
  initialState,

  on(
    basketGroupingChanged,
    (state, { groupingType }): State => ({
      ...state,
      selectedGroupingType: groupingType,
    }),
  ),
  on(
    resolveActiveBasketComplete,
    (state): State => ({
      ...state,
      activeBasketIdResolved: true,
    }),
  ),
  on(
    applySortingBasketItems,
    initSortingBasketItems,
    (state, { sorting }): State => {
      return {
        ...state,
        activeSortingType: sorting.type,
        activeSortingDirection: sorting.direction,
      };
    },
  ),
);
